import { render } from "./LmsAcademyPage.vue?vue&type=template&id=cd710a3a"
import script from "./LmsAcademyPage.vue?vue&type=script&lang=js"
export * from "./LmsAcademyPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__